.root {
	position: relative;
	flex-shrink: 0;
}

.trigger {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 34px;
	height: 34px;
	padding: 0;
	background: transparent;
	border: none;
	border-radius: 50%;
	color: var(--parrot-chat-text-muted);
	cursor: pointer;
	transition: color 0.12s, background 0.12s;
}

.trigger:hover,
.trigger[aria-expanded="true"] {
	color: var(--parrot-chat-text);
	background: var(--parrot-chat-menu-hover);
}

.trigger svg {
	width: 20px;
	height: 20px;
	fill: none;
	stroke: currentColor;
	stroke-width: 2;
	stroke-linecap: round;
	stroke-linejoin: round;
	transition: transform 0.18s ease;
}

/* Rotate the "+" 45° into an "×" while the menu is open. */
.trigger[aria-expanded="true"] svg {
	transform: rotate(45deg);
}


.menu {
	composes: surface from "../../menu.module.css";
	position: absolute;
	bottom: calc(100% + 8px);
	left: 0;
	min-width: 184px;
	z-index: 5;
	animation: menuIn 0.14s ease-out;
}

.item {
	composes: itemBase from "../../menu.module.css";
	display: flex;
	align-items: center;
	gap: 10px;
}

.item:hover {
	color: var(--parrot-chat-text);
	background: var(--parrot-chat-menu-hover);
}

.item svg {
	width: 16px;
	height: 16px;
	flex-shrink: 0;
	fill: none;
	stroke: currentColor;
	stroke-width: 2;
	stroke-linecap: round;
	stroke-linejoin: round;
}

@keyframes menuIn {
	from {
		opacity: 0;
		transform: translateY(4px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

.disclaimer {
	padding: 8px 10px;
	border-top: 1px solid var(--parrot-chat-border);
	font-size: 11px;
	color: var(--parrot-chat-success);
	line-height: 1.4;
}

/* Floated so the first line sits beside the icon and later lines wrap under it. */
.disclaimer svg {
	width: 14px;
	height: 14px;
	float: left;
	margin: 1px 6px 0 0;
	fill: none;
	stroke: currentColor;
	stroke-width: 2;
	stroke-linecap: round;
	stroke-linejoin: round;
}

.disclaimer a {
	color: var(--parrot-chat-accent);
	text-decoration: none;
	cursor: pointer;
}

.disclaimer a:hover {
	text-decoration: underline;
}
